<template>
  <v-col class="col-3">
    <v-card elevation="0">
      <v-card-title>
        <v-icon class="mr-2"> mdi-bell </v-icon>
        {{ $t("_details_des_pertes_&_alarmes_") }}
      </v-card-title>

      <hr />

      <!-- Generic Data -->
      <v-card-title v-show="!fromSmartguard">{{ $t("_donnees_") }}</v-card-title>
      <v-card-text v-show="!fromSmartguard">
        <v-row>
          <div class="col-4">
            <h3 class="mb-3">
              <b>{{ installation.audit_start_date | moment("DD/MM/YYYY") }}</b>
            </h3>
            <div class="gray--text">{{ $t("_debut_audit_") }}</div>
          </div>
          <div class="col-4">
            <h3 class="mb-3">
              <b>{{ installation.audit_end_date | moment("DD/MM/YYYY") }}</b>
            </h3>
            <div class="gray--text">{{ $t("_fin_audit_") }}</div>
          </div>

          <div class="col-4">
            <h3 class="mb-3">
              <b> {{ installation.data_completeness }}% </b>
            </h3>
            <div class="gray--text">{{ $t("_completude_") }}</div>
          </div>
        </v-row>
      </v-card-text>

      <hr />

      <!-- Losses list -->
      <v-card-title class="d-flex justify-space-between">
        <table style="width: 100%">
          <tr style="vertical-align: middle">
            <td style="text-align: left">
              {{ $t("_sous_performances_") }}
            </td>
            <td style="text-align: right">
              <span class="orange--text mx-2"
                ><b>{{ constantsLosses.sum }} {{ getUnitSymbol() }}</b></span
              >
            </td>
          </tr>
        </table>
      </v-card-title>

      <v-card-text>
        <table style="width: 100%">
          <tr style="vertical-align: middle">
            <td style="text-align: left">
              <v-treeview
                :items="constantsLosses.tree"
                :transition="true"
                open-on-click
                dense
              >
                <template v-slot:label="{ item }">
                  <span
                    :class="'wrap-text'"
                    v-bind:style="'color: ' + item.color"
                  >
                    {{ $t(item.name) }}
                  </span>
                </template>
                <template v-slot:append="{ item }">
                  <span
                    v-bind:style="
                      'color: ' +
                      item.color +
                      ';background-color:' +
                      item.bck_color
                    "
                  >
                    <b>{{ item.total }} {{ getUnitSymbol() }}</b>
                  </span>
                </template>
              </v-treeview>
            </td>
          </tr>
          <tr style="vertical-align: middle">
            <td style="text-align: center">
              <v-toolbar flat dense>
                <v-btn-toggle v-model="unit_filter" dense mandatory rounded>
                  <v-btn :value="1" style="height: 25px">
                    <v-icon>mdi-percent</v-icon>
                  </v-btn>
                  <v-btn :value="2" style="height: 25px">
                    <v-icon>mdi-counter</v-icon>
                  </v-btn>
                  <v-btn :value="3" style="height: 25px">
                    <v-icon>mdi-cash-multiple</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-toolbar>
            </td>
          </tr>
        </table>
      </v-card-text>

      <hr />
      <!-- Additional Links -->
      <v-card-text>
        <div>
          <router-link
            :to="{
              name: 'dashboard-under-perf',
              params: {
                id: this.$route.params.id,
                scenario_name: getMenu(),
              },
              query: {
                fromSmartguard: fromSmartguard,
              },
            }"
          >
            <v-icon class="mr-2"> mdi-chart-bar-stacked </v-icon>
            {{ $t("_historique_de_sous_performance_") }}
          </router-link>
          <br />
          <router-link
            v-if="canNavigate != false"
            :to="{
              name: 'dashboard-losses-waterfall',
              params: {
                id: this.$route.params.id,
                scenario_name: getMenu(),
              },
              query: {
                fromSmartguard: fromSmartguard,
              },
            }"
          >
            <v-icon class="mr-2"> mdi-chart-bar-stacked </v-icon>
            {{ $t("_cascade_des_pertes_") }}
          </router-link>
          <div v-else>
            <v-icon class="mr-2"> mdi-chart-bar-stacked </v-icon>
            {{ $t("_cascade_des_pertes_") }}
            <span class="icon-badge">SOON</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import compdata from "../../utils/compute_data";
import moment from "moment";

export default {
  props: {
    installation: {
      type: Object,
      required: true,
    },
    fromSmartguard: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      unit_filter: 1,
    };
  },

  watch: {
    unit_filter: {
      handler() {
        this.getConstantLosses();
      },
      // immediate: true,
    },
  },

  computed: {
    moment() {
      return moment;
    },
    dates() {
      return this.$store.state.parametersStore.dates;
    },

    canNavigate() {
      return true;
    },

    constantsLosses() {
      return this.getConstantLosses();
    },

    losses() {
      return this.constantsLosses
        .filter((loss) => loss.scenario_name.includes(this.getMenu()))
        .map((loss) => loss);
    },
  },

  methods: {
    getMenu() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      )?.target_menu;
    },

    getUnitSymbol() {
      return this.$t(compdata.getUnit(this.unit_filter, true));
    },

    getConstantLosses() {
      let constLosses = JSON.parse(
        JSON.stringify(this.$store.getters.constants.losses)
      );
      let sumLoss = 0;
      for (let idx_item = 0; idx_item < constLosses.length; idx_item++) {
        const item = constLosses[idx_item];
        let constant =
          compdata.getUnit(this.unit_filter) === "percent"
            ? this.installation["eac_sim"]
            : compdata.getUnit(this.unit_filter) === "currency"
            ? this.installation["kwh_price"]
            : null;

        let dbValueL0 =
          this.installation[item.id] !== undefined
            ? compdata.getComputedValue(
                this.installation[item.id],
                1,
                constant,
                this.unit_filter
              )
            : null;

        let sumChildLoss = 0;
        let childList = [];
        if (item.children.length > 0) {
          for (
            let idx_child = 0;
            idx_child < item.children.length;
            idx_child++
          ) {
            const child = item["children"][idx_child];

            let dbValueL1 =
              this.installation[child.id] !== undefined
                ? compdata.getComputedValue(
                    this.installation[child.id],
                    1,
                    constant,
                    this.unit_filter
                  )
                : null;

            constLosses[idx_item].children[idx_child].enabled =
              dbValueL1 != null;
            constLosses[idx_item].children[idx_child].total =
              dbValueL1 != null ? dbValueL1 : 0;

            sumChildLoss += constLosses[idx_item].children[idx_child].total;
          }
          childList = constLosses[idx_item].children.filter(
            (item) => item.enabled
          );
        }

        constLosses[idx_item].total =
          dbValueL0 != null &&
          dbValueL0 > 0 &&
          Math.round(sumChildLoss * 10) / 10 === 0
            ? dbValueL0
            : Math.round(sumChildLoss * 10) / 10;
        constLosses[idx_item].children = JSON.parse(JSON.stringify(childList));
        sumLoss += constLosses[idx_item].total;
      }

      return {
        tree: JSON.parse(
          JSON.stringify(constLosses.filter((item) => item.enabled))
        ),
        sum: Math.round(sumLoss * 10) / 10,
      };
    },
  },
};
</script>

<style scoped>
.border {
  border: lightgray 1px solid;
}

.v-card__title {
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.icon-badge {
  position: absolute;
  background-color: #ff9b28;
  color: white;
  right: 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  padding: 2px 5px;
  text-transform: uppercase;
  white-space: nowrap;
}

.wrap-text {
  display: inline-block;
  max-width: 200px; /* adjust as needed */
  white-space: normal;
  word-wrap: break-word;
}
</style>
